export default __webpack_public_path__ + "static/media/meter-series-img.5f839b51.png";